import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const OnboardingChecklist = ({ user, invoices }) => {
  const userId = user?._id || user?.id;
  const storageKey = userId ? `ainix_onboarding_dismissed_${userId}` : 'ainix_onboarding_dismissed';
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(storageKey) === '1');

  if (dismissed || !userId) return null;

  const billFromDone = Boolean(
    user?.profile?.firstName && (user.profile.company || user.profile.lastName || user.profile.phone)
  );
  const hasInvoice = (invoices || []).length > 0;
  const downloaded = localStorage.getItem(`ainix_downloaded_pdf_${userId}`) === '1';

  if (billFromDone && hasInvoice && downloaded) return null;

  const dismiss = () => {
    localStorage.setItem(storageKey, '1');
    setDismissed(true);
  };

  const items = [
    {
      done: billFromDone,
      label: 'Complete bill-from on your profile',
      to: '/profile',
    },
    {
      done: hasInvoice,
      label: hasInvoice ? 'Invoice ready' : 'Create or claim your first invoice',
      to: '/invoices/new',
    },
    {
      done: downloaded,
      label: 'Download a PDF',
      to: '/invoices',
    },
  ];

  return (
    <div className="card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">Get started</h2>
          <p className="text-sm text-gray-600 mt-1">Three steps to your first professional invoice.</p>
        </div>
        <button type="button" onClick={dismiss} className="text-sm text-gray-500 hover:text-gray-700">
          Dismiss
        </button>
      </div>
      <ul className="mt-4 space-y-3">
        {items.map((item) => (
          <li key={item.label} className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <CheckCircle className={`w-5 h-5 ${item.done ? 'text-green-500' : 'text-gray-300'}`} />
              <span className={item.done ? 'text-gray-500 line-through' : 'text-gray-800'}>
                {item.label}
              </span>
            </div>
            {!item.done && (
              <Link to={item.to} className="text-sm font-medium text-primary-600 hover:text-primary-700">
                Go
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OnboardingChecklist;
